$(document).ready(function() {
	$('.owl-badges').owlCarousel({
    dots: false,
    items: 7,
    margin: 10,
    responsiveClass: true,
    loop: false,
    nav: true,
    mouseDrag: false,
    navText: ['<svg class="icon--root icon--chevron-left" viewBox="0 0 12 20"> <path d="M2.648 10l8.613-8.614L9.99.114.102 10l9.887 9.886 1.272-1.272z" fill-rule="nonzero" /> </svg>','<svg class="icon--root icon--chevron-right" viewBox="0 0 12 20"> <path d="M8.716 10L.102 18.614l1.273 1.272L11.261 10 1.375.114.102 1.386z" fill-rule="nonzero" /> </svg>'],
    responsive:{
      1024: {
        items:7,
        mouseDrag: false,
        touchDrag: false
      },
      820: {
        items: 6
      },
      760: {
        items:5,
        mouseDrag: true,
        touchDrag: true
      },
      400: {
        items:4,
        loop: true,
        center: true,
        autoWidth:true,
        margin: 35,
        mouseDrag: true,
        touchDrag: true
      },
      0: {
        items: 3,
        margin: 45,
        mouseDrag: true,
        touchDrag: true
      }
    }
  });

  let defaultIndex = $('.product-media--thumb[data-active="true"]').data('index');
  $('.product-media--dot[data-index="'+defaultIndex+'"]').addClass('active');

  $('.product-media--thumb').click(function() {
    let getIndex = $(this).data('index');
    $('.product-media--dot').removeClass('active');
    $('.product-media--dot[data-index="'+getIndex+'"]').addClass('active');
  });

  $('.product-media--dot').click(function() {
    let getIndex = $(this).data('index');
    $('.product-media--dot').removeClass('active');
    $('.product-media--dot[data-index="'+getIndex+'"]').addClass('active');
    $('.product-media--featured').attr('data-active', 'false');
    $('.modal--link[data-index="'+getIndex+'"] .product-media--featured').attr('data-active', 'true');
    $('.product-media--thumb').attr('data-active', 'false');
    $('.product-media--thumb[data-index="'+getIndex+'"]').attr('data-active', 'true');
  });

  $('.product-media--thumb, .image--root, image--container').click(function(e) {
    e.preventDefault();
  }); 

  $('.radios--packs .radios--value-button').on('click', function () {
    let getPackQty = $(this).data('qty');
    // Habilitar estas líneas si se agrega campo de cantidad por packs
    //let globalQty = $('.quantity-packs').val();
    //let getQty = getPackQty * globalQty;
    //let updateQty = parseInt(getQty);
    //$('#quantity').val(parseInt(updateQty));
    $('#quantity').val(parseInt(getPackQty));
  });

  $('.pack-plus').on('click', function () {
    let getQty = $('.quantity-packs').val();
    let newQty = parseInt(getQty) + 1;
    newQty = parseInt(newQty);

    let packQty = $("input[name=packs]:checked").val();
    let newPackQty = parseInt(newQty) * packQty;
    $('.quantity-packs').val(newQty);
    $('#quantity').val(parseInt(newPackQty));
  });

  $('.pack-minus').on('click', function () {
    let getQty = $('.quantity-packs').val();
    let newQty = parseInt(getQty) - 1;
    newQty = parseInt(newQty);
    if(newQty > 0) {
      let packQty = $("input[name=packs]:checked").val();
      let newPackQty = parseInt(newQty) * packQty;
      $('.quantity-packs').val(parseInt(newQty));
      $('#quantity').val(parseInt(newPackQty));
    }
  });

  /* Timer for packs quantity */
  var typingTimer;               
  var doneTypingInterval = 1000;  
  var $input = $('.quantity-packs');

  $input.on('keyup', function () {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTyping, doneTypingInterval);
  });

  $input.on('keydown', function () {
    clearTimeout(typingTimer);
  });

  function doneTyping () {
    let packQty = $("input[name=packs]:checked").val();
    let getQty = $('.quantity-packs').val();
    let newPackQty = parseInt(getQty) * packQty;
    $('#quantity').val(parseInt(newPackQty))
  }



  /***************************************/
  /* Default Quantity */

  $('.quantity-plus').on('click', function () {
    let getQty = $('#quantity').val();
    let newQty = parseInt(getQty) + 1;
    $('#quantity').val(parseInt(newQty));
  });

  $('.quantity-minus').on('click', function () {
    let getQty = $('#quantity').val();
    let newQty = parseInt(getQty) - 1;
    if(newQty > 0) {
      $('#quantity').val(parseInt(newQty));
    }
  });
});